module.exports = "/packs/media/images/budget2-4cc2c6e2eef112723674106647246a4b.jpg";